import { environment } from '../../../environments/environment';
import type { AssetsMockTimingConfig } from '../../../environments/environment.model';

/** sessionStorage JSON overrides `environment.mockApiTiming.assets` (devtools only). */
export const ASSETS_MOCK_TIMING_STORAGE_KEY = 'momentum.mock.assets.timing';

export interface ResolvedAssetsMockTiming {
  responseDelayMs: number;
  analysisReadyAfterGetPolls: number;
}

const DEFAULTS: ResolvedAssetsMockTiming = {
  responseDelayMs: 400,
  analysisReadyAfterGetPolls: 2,
};

function coerceTiming(
  partial: AssetsMockTimingConfig | null | undefined,
): ResolvedAssetsMockTiming {
  const responseDelayMs =
    typeof partial?.responseDelayMs === 'number' && partial.responseDelayMs >= 0
      ? partial.responseDelayMs
      : DEFAULTS.responseDelayMs;
  const analysisReadyAfterGetPolls =
    typeof partial?.analysisReadyAfterGetPolls === 'number' &&
    partial.analysisReadyAfterGetPolls >= 1
      ? Math.floor(partial.analysisReadyAfterGetPolls)
      : DEFAULTS.analysisReadyAfterGetPolls;

  return { responseDelayMs, analysisReadyAfterGetPolls };
}

function readSessionOverride(): AssetsMockTimingConfig | null {
  try {
    const raw = globalThis.sessionStorage?.getItem(ASSETS_MOCK_TIMING_STORAGE_KEY);
    if (!raw?.trim()) {
      return null;
    }
    return JSON.parse(raw) as AssetsMockTimingConfig;
  } catch {
    return null;
  }
}

/** Effective assets mock timing: defaults ← environment ← sessionStorage. */
export function getAssetsMockTiming(): ResolvedAssetsMockTiming {
  return coerceTiming({
    ...DEFAULTS,
    ...environment.mockApiTiming?.assets,
    ...readSessionOverride(),
  });
}
